import React, { useState } from 'react';
import { css } from '@emotion/core';
import Zoom from '@material-ui/core/Zoom';

export default function WrapperZoomInWithBlurBg({
    open,
    children = () => {},
    onZoomedIn = () => {},
    onZoomedOut = () => {}
}) {
    const [zoomed, setZoomed] = useState(false);

    function handleZoomEntered() {
        setZoomed(true);
        onZoomedIn();
    }

    return (
        <>
            <div css={[open && backgroundWrap]}></div>
            <Zoom
                in={open}
                timeout={timeConfig}
                onEntered={handleZoomEntered}
                onExited={onZoomedOut}
            >
                {children({ zoomed })}
            </Zoom>
        </>
    );
}

const timeConfig = {
    appear: 500,
    enter: 1000,
    exit: 500
};
const backgroundWrap = css`
    right: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.56);
    backdrop-filter: blur(10.8731px);
    z-index: 3;
`;
